import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'Actions/router';
import SelectIndicatorsBundle from 'Components/selectIndicatorsBundle';
import { makeIndicatorWithId } from 'Selectors/indicatorWithId';
import * as styles from './selectIndicatorsInput.css';

const SelectIndicatorsInput = ({ id, label, onChange, checked, children }) => (
  !children ? (
    <li className={styles.li} key={id}>
      <span>
        <input
          className={styles.input}
          checked={checked}
          id={id}
          type="checkbox"
          onChange={onChange}
        /><label className={styles.label} htmlFor={id}>{label}</label>
      </span>
    </li>
  ) : (
    <SelectIndicatorsBundle id={id} key={id} />
  )
);

SelectIndicatorsInput.defaultProps = {
  checked: false,
  children: false,
};

SelectIndicatorsInput.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
  ]),
};

const mapStateToProps = (state, props) => makeIndicatorWithId()(state, props);

const mapDispatchToProps = (dispatch) => ({
  onChange: (id) => dispatch(push({ indicators: id })),
});

const mergeProps = (stateProps, { onChange }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onChange: () => onChange(`${stateProps.id}`),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SelectIndicatorsInput);

// Testing exports
export {
  SelectIndicatorsInput,
  mapDispatchToProps,
  mergeProps,
};



// WEBPACK FOOTER //
// ./app/components/selectIndicatorsInput/index.js